module.exports = __webpack_public_path__ + "img/spacing-example-simple-details-4.82c77d14.png";